import { fetchEntity } from '@classpass/saga-tools';
import { call, takeEvery } from 'redux-saga/effects';
import { userLogout } from 'redux/saga/entities/bound';
import { gtmSafeRedirect } from 'redux/saga/helpers';

const USER_LOGOUT = 'NAVIGATION/USER_LOGOUT';

export const logoutUser = () => ({ type: USER_LOGOUT });

export function* doLogoutUser(client) {
  yield call(fetchEntity, userLogout, [client]);
  return yield call(gtmSafeRedirect, '/');
}

export function* watchUserLinksSaga(client) {
  yield takeEvery(logoutUser().type, doLogoutUser, client);
}
